module.exports = __webpack_public_path__ + "img/retrospect-process-2-mobile.73a9f685.jpg";